import { render, staticRenderFns } from "./BonDeCommande.vue?vue&type=template&id=4bd3694f&scoped=true"
import script from "./BonDeCommande.vue?vue&type=script&lang=js"
export * from "./BonDeCommande.vue?vue&type=script&lang=js"
import style0 from "./BonDeCommande.vue?vue&type=style&index=0&id=4bd3694f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd3694f",
  null
  
)

export default component.exports